import type { ButtonConfig } from '../../declare'
import { useMemo } from 'react'
import { EasyModal, EasyIcon, EasyDrawer, FormPage } from 'src/components'

type Props = {
  config: ButtonConfig
}

const CustomModalBtn = (props: Props) => {
  const formData = useMemo(() => {
    const { __RECORD__: record } = props.config
    return { formId: record.ID }
  }, [props.config.__RECORD__])

  const slot = useMemo(() => {
    const { LABEL, ICON } = props.config
    return (
      <span>
        <EasyIcon type={ICON} defaultIcon='FormOutlined' className='fz-16' />
        <span title={LABEL} className='pd-l4'>{LABEL}</span>
      </span>
    )
  }, [])

  const { FORM_CODE, DRAWER_MODAL, WIDTH } = props.config
  if (DRAWER_MODAL) {
    return (
      <EasyDrawer drawer={{ title: FORM_CODE }} slot={slot}>
        <FormPage formCode={FORM_CODE} formData={formData} />
      </EasyDrawer>
    )
  }
  return (
    <EasyModal modal={{ title: FORM_CODE, width: WIDTH }} slot={slot}>
      <FormPage formCode={FORM_CODE} formData={formData} />
    </EasyModal>
  )
}

export default CustomModalBtn